import auth from './auth';
import web_form from './web_form';
import rating from './rating';

export default {
	auth,
	web_form,
	rating
};
